export default function formatTimeString(seconds) {
  if ([null, undefined].includes(seconds)) return "";
  if (Number.isNaN(seconds)) return "NaN";
  const minutesPart = Math.floor(seconds / 60);
  const secondsPart = Math.floor(seconds % 60);
  return `${minutesPart}:${secondsPart.toString().padStart(2, "0")}`;
}
